import { render } from "./C4Submit.vue?vue&type=template&id=6356da7c"
import script from "./C4Submit.vue?vue&type=script&lang=js"
export * from "./C4Submit.vue?vue&type=script&lang=js"

import "./C4Submit.vue?vue&type=style&index=0&id=6356da7c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__